import axios from 'axios';
import { IQuoteFilters } from '../../redux/state/quotesState';
import { quoteFields } from "../../util/quote/quoteFields";
export const initialFilter = {
    orderStatus: [],
    account_id: "",
    contact_id: "",
    source: "cp",
    cp_user_id: '',
    orderIdentity: "",
    orderNo: "",
    mainSearch: ""

};
export const fetchQuotes = (limit: number = 50, offset: number = 0, order: string, orient: string = "asc", filters: IQuoteFilters = initialFilter) => {
    let url = `/api/v1/orders?term[orderType]=Quote&source=cp&limit=${limit}&offset=${offset}&order=${order}&orient=${orient}`;
    const query = new URLSearchParams(window.location.search);
    for (let key in filters) {
        if (key == "mainSearch") {
            continue;
        }
        if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'cp_user_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'source')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'account_id')) {
            url += `&${key}=${filters[key]}`;
        } else if (filters[key] && filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'orderIdentity')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters[key] && filters["mainSearch"] == "" && filters[key].length && !Array.isArray(filters[key]) && (key === 'orderNo')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters[key] && filters[key].length && filters[key] && !Array.isArray(filters[key]) && (key !== 'account_id' && key !== 'orderIdentity' && key !== 'orderNo')) {
            url += `&term[${key}]=${filters[key]}`;
        } else if (filters[key] && filters[key] && filters[key].length && Array.isArray(filters[key])) {
            filters[key].forEach(el => {
                url += `&term[${key}][]=${el}`
            });
        } else if (filters[key] && filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id')) {
            url += `&${key}=${filters[key]}`;
        }
    }
    if (filters["mainSearch"] != "") {
        url += `&search=${filters["mainSearch"]}`;
    }
    return axios.get(url);
};
export const fetchQuote = (quoteId) => {
    let url = `/api/v1/orders/` + quoteId + "?source=cp";
    return axios.get(url);
};
export const fetchQuoteItems = (quoteId) => {
    let url = `/api/v1/orders/` + quoteId + "/items";
    return axios.get(url);
};
export const fetchQuoteItemDetail = (quoteID, quoteItemID) => {

    let url = `/api/v1/orders/` + quoteID + "/items/" + quoteItemID + "?get_personalizations=1";
    const query = new URLSearchParams(window.location.search);
    return axios.get(url);
};
export const fetchQuoteItemRowDecoDetail = (quoteID, quoteItemID, row_id) => {

    let url = `/api/v1/orders/` + quoteID + "/items/" + quoteItemID + "/rows/" + row_id + "/decorations";
    const query = new URLSearchParams(window.location.search);
    return axios.get(url);
};
export const fetchQuoteItemRowDetail = (quoteID, quoteItemID, row_id) => {
    let url = `/api/v1/orders/` + quoteID + "/items/" + quoteItemID + "/rows/" + row_id;
    return axios.get(url);
};
export const fetchQuoteItemRows = (quoteID, quoteItemID) => {
    let url = `/api/v1/orders/` + quoteID + "/items/" + quoteItemID + "/rows";
    return axios.get(url);
};
export const fetchQuoteItemRowsCharges = (quoteID, quoteItemID) => {
    let url = `/api/v1/orders/` + quoteID + "/items/" + quoteItemID + "/charges";
    return axios.get(url);
};
export const deleteQuoteItem = (quoteID, quoteItemID) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID;
    return axios.delete(url);
};
export const createQuoteItemRow = (quoteID, quoteItemID, data) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID + `/rows`;
    return axios.post(url, data);
};
export const deleteQuoteItemRow = (quoteID, quoteItemID, row_id) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID + `/rows/` + row_id;
    return axios.delete(url);
};
// AA-27118 - write an edited quantity back to an existing matrix row.
//
// `data` MUST be a complete row: OrdersDao::updateLineApparelAdvance is a single UPDATE
// that sets every column from the payload with a hardcoded fallback, so an omitted field is
// written with its default rather than left alone. Omitting priceStrategy, for instance,
// flips a hand-priced row to PRICE_BREAK and the next recalculation re-derives the
// customer's price. Build the body with `toRowUpdatePayload`.
export const updateQuoteItemRow = (quoteID, quoteItemID, rowID, data) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID + `/rows/` + rowID;
    return axios.put(url, data);
};

// AA-27118 - map one `get-quote-catalogue` matrix row to the shape the v1 row endpoints
// expect, with a new quantity.
//
// The catalogue hands rows straight out of getQuoteOrderDetailsAdvance, so they arrive in
// the LEGACY key shape (matrixUpdateId, itemSku, taxValue, taxOff, imageUrl). The endpoints
// run OrderItemRow::toRequest, which maps PUBLIC -> legacy, so the body needs `id`,
// `product.sku`, `tax`, `disableTax`, `image`. The two are not interchangeable.
//
// Three details worth keeping in mind here:
//   - `quantity` must be a NUMBER and must always be present. The backend tests
//     `$row['quantity'] == 0` loosely, and a missing key is null == 0 in PHP, which DELETES
//     the row. (An empty string is not == 0, so '' and 0 behave differently.)
//   - totalPrice and totalCost are stored columns, not derived on write, and on a line
//     flagged doNotCalculateAtOrder the backend derives the unit price back out of
//     totalPrice - so a stale total silently rewrites the price.
//   - an empty colour or size is rewritten to 'No Color' / 'OSFA' by the DAO, so never echo
//     '' back for those; it would rename the row.
export const toRowUpdatePayload = (matrixRow, nextQuantity, nextColor?, nextSize?) => {
    const quantity = Number(nextQuantity);
    const price = Number(matrixRow.price || 0);
    const cost = Number(matrixRow.cost || 0);
    return {
        id: matrixRow.matrixUpdateId,
        color: nextColor || matrixRow.color || 'No Color',
        size: nextSize || matrixRow.size || 'OSFA',
        quantity,
        price: matrixRow.price,
        totalPrice: price * quantity,
        cost: matrixRow.cost,
        totalCost: cost * quantity,
        profit: (price - cost) * quantity,
        costStrategy: matrixRow.costStrategy,
        priceStrategy: matrixRow.priceStrategy,
        poType: matrixRow.poType,
        warehouse: matrixRow.warehouse,
        tax: matrixRow.taxValue,
        disableTax: matrixRow.taxOff,
        image: matrixRow.imageUrl,
        product: { sku: matrixRow.itemSku, margin: matrixRow.productMargin },
        distributorWarehouse: {
            id: matrixRow.distributorWarehouseId,
            name: matrixRow.distributorWarehouseName,
        },
        provincialTaxRate: matrixRow.provincialTaxRate,
        countryTaxRate: matrixRow.countryTaxRate,
        provincialTaxAmount: matrixRow.provincialTaxAmount,
        countryTaxAmount: matrixRow.countryTaxAmount,
    };
};

// AA-27118 - body for a new (colour, size) row on an existing line. The endpoint takes an
// ARRAY of rows. Pricing fields are copied from a sibling row on the same line where one
// exists, so the new row is priced like its neighbours rather than from the DAO's defaults
// (which differ from the update path: MANUAL here, PRICE_BREAK there).
export const toRowCreatePayload = (templateRow, color, size, nextQuantity) => {
    const template = templateRow || {};
    const quantity = Number(nextQuantity);
    const price = Number(template.price || 0);
    const cost = Number(template.cost || 0);
    return {
        color: color || 'No Color',
        size: size || 'OSFA',
        quantity,
        price: template.price || '0',
        totalPrice: price * quantity,
        cost: template.cost || '0',
        totalCost: cost * quantity,
        profit: (price - cost) * quantity,
        costStrategy: template.costStrategy || 'MANUAL',
        priceStrategy: template.priceStrategy || 'MANUAL',
        poType: template.poType || 'DropShip',
        warehouse: template.warehouse || '0',
        tax: template.taxValue || '0',
        disableTax: template.taxOff || '0',
        image: template.imageUrl || '',
        product: { sku: '', margin: template.productMargin || '0' },
    };
};
export const updateOrderStatus = (quoteID, data, session) => {
    let url = `/api/v1/orders/` + quoteID;
    url += `?source=cp`;
    if (session) {
        url += `&cp_user_id=` + session.user.contactId;
    }
    return axios.put(url, data);
};

export const changeStatus = (id, status, session) => {
    let url = `/api/v1/orders/change-status`;
    url += `?source=cp`;
    if (session) {
        url += `&cp_user_id=` + session.user.contactId;
    }
    return axios.put(url, {
        id,
        status,
        complete: 1
    });

}
export const fetchDecorationLocations = () => {
    let url = `/api/v1/decorations/locations`;
    return axios.get(url);
};
export const createCharge = (quoteID, id, data) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + id + `/charges`;
    return axios.post(url, data);
};
export const savePersonalizations = (quoteID, quoteItemID, data) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID;
    url += `?source=cp`;
    return axios.put(url, data);
};
export const deleteQuoteItemRows = (quoteID, quoteItemID, row_ids) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID + `/rows/` + row_ids[0];
    let urlParams = ""
    row_ids.forEach((rowID, key) => {
        if (key != 0) {
            if (urlParams == "") {
                urlParams += `?addon_ids[]=${rowID}`
            } else {
                urlParams += `&addon_ids[]=${rowID}`
            }
        }
    });
    url += urlParams;
    return axios.delete(url);
};
export const deleteRowDecoration = (quoteID, quoteItemID, row_id, deco_id) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID + `/rows/` + row_id + '/decorations/' + deco_id;
    return axios.delete(url);
};
export const deletePersonalizationCharge = (quoteID, quoteItemID, chargeID) => {
    let url = `/api/v1/orders/` + quoteID + `/items/` + quoteItemID + `/charges/` + chargeID;
    return axios.delete(url);
};

export const fetchQuoteContentDetail = (quoteID) => {
    const url = `/content/get-quote-order-details`;
    const params = {
        "snapshot": "1",
        "id": quoteID
    }
    return axios.post(url, params);
};

export const sendComments = (data, session) => {
    let url = `/api/v1/orders/send-comment`;
    return axios.post(url, data);
};

export const getSalesRep = (quoteId) => {
    let url = `/api/v1/orders/get-sales-rep?quoteId=` + quoteId;
    return axios.get(url);
};

export const getProductDisplayDefaultMessage = (quoteId) => {
    let url = `/api/v1/orders/get-product-display-default-message?quoteId=` + quoteId;
    return axios.get(url);
};

export const getQuoteCatalogue = (quoteId) => {
    let url = `/api/v1/orders/get-quote-catalogue?quoteId=` + quoteId;
    return axios.get(url);
};
